/**
 * Cria um filtro padrão para que o programador possa obter os many mais facilmente e não
 * repetir tanto código
 *
 * @params {object} {
 *     criteria: {string} define o critério da projection,
 *     entity: {string} é a entidade que é filha do model atual,
 *     entityId: {integer} é o id do model atual que será usado para compor o filtro
 * }
 *
 */


Monet.Model = {

    doAjax: function(obj, url, success, error){

        var filter = obj.filter;
        if (typeof filter !== 'string') {
            filter = JSON.stringify(obj.filter);
        }

        var ajax = new Monet.Ajax();
        ajax.url =  url;
        ajax.method = 'post';
        ajax.data = filter;
        ajax.success = success;
        if(error) {
            ajax.error = error;
        } else {
            ajax.error = function (xhr) {
                Monet.Configurations.errorNotification(null, xhr, null, null);
            };
        }

        ajax.send();
    },

    hasMany: function (obj) {
        let criteria = "";
        let service = "";
        let entity = "";
        let filter = "/restrictions";
        let successWrapper = null;

        if (obj) {

            filter = obj.options.filter || filter;

            if (!obj.collection || !obj.model || !obj.parent) {
                return false;
            }

            entity = obj.parent.url().replace("/" + obj.parent.id, "").toLowerCase();

            service = new obj.model().url().replace("/", "");

            if (obj.options) {

                if (obj.options.criteria) {
                    criteria = "?criteria=" + obj.options.criteria;
                }

                if (obj.options.success) {

                    successWrapper = (function (success, Collection, Model) {

                        return function (data) {

                            var col = new Collection();

                            $.each(data, function (index, item) {

                                var mod = new Model();

                                mod.set(item);
                                col.add(mod);

                            });

                            success(col);

                        };

                    })(obj.options.success, obj.collection, obj.model);

                }

            }

        }
        const params = {
          filter: {
            criteriaChain:[
              {
                and:[
                  {
                    attr: `${entity}.id`,
                    eq: obj.parent.id
                  }
                ]
              }
            ]
          }
        };
        this.doAjax(params,
            service + filter + criteria, function (data) {
            if (successWrapper) {
                successWrapper(data);
            }
        });
    },

    fetchWithCriteria: function (objParameter) {

        var model = objParameter.model;
        var obj = objParameter.options;
        var modelId = model.id;
        var service = model.url().split("/")[0];
        var criteria = "?criteria=" + obj.criteria;

        if (obj && obj.criteria) {
                const params = {
                    criteriaChain:[
                    {
                        and:[
                            {
                                attr: "id",
                                eq: modelId
                            }
                        ]
                    }
                    ]
                },
                success = function (data) {
                    if (obj.success) {

                        model.set(data[0]);

                        obj.success(model);
                    }
                };

            this.doAjax(params, service + '/restrictions' + criteria, success);

        }

        return false;

    },

    searchWithCriteria: function (objParameter) {

        var model = objParameter.model;
        var obj = objParameter.options;
        var searchJsonStr = JSON.stringify(obj.searchJson);
        var service = model.url().split("/")[0];
        var criteria = "?criteria=" + obj.criteria;

        if (obj && obj.criteria) {

            var success = function (data) {
                if (typeof(obj.success) !== "undefined") {

                    model.set(data[0]);

                    obj.success(model);
                }
            };

            this.doAjax({filter: searchJsonStr}, service + '/filter' + criteria, success);

        }

        return false;
    },
    searchAllWithCriteria: function (objParameter) {

        var model = objParameter.model;
        var obj = objParameter.options;
        var searchJsonStr = JSON.stringify(obj.searchJson);
        var service = model.url().split("/")[0];
        var criteria = "?criteria=" + obj.criteria;

        if (obj && obj.criteria) {

            var success = function (data) {
                if (obj.success) {

                    model.set(data);

                    obj.success(model);
                }
            };

            this.doAjax({filter: searchJsonStr}, service + '/filter' + criteria, success);
        }

        return false;
    },

    filterWithRestrictions: function (objParameter) {

        var model = objParameter.model;
        var obj = objParameter.options;
        var modelId = model.id;
        var service = model.url().split("/")[0];
        var criteria = null;
        var restrictionUrl = objParameter.restrictionUrl || '/restrictions';
        var body = objParameter.body || '{"attr":"id","eq":'+ modelId +'}';

        if (obj && obj.criteria) {

            var url = service + restrictionUrl + '?criteria=' + obj.criteria,
                success = function (data) {
                    if (obj.success) {

                        model.set(data[0]);

                        obj.success(model);
                    }
                };

            this.doAjax({filter: body}, url, success, obj.error);
        }

        return false;
    }

};